<template>
  <div class="content flex-box" v-if="activity">
    <data-list
      ref="dataList"
      class="flex-grow"
      url="/activity/activity-dining-spec"
      :add-btn="false"
      :hide-action="!editable"
      hide-show-detail
      hide-edit
      hide-delete
      :modal-width="480"
      :modal-form="modalForm"
      :query="query"
      :action="action"
      :columns="columns"
      :search-key-type="{dining_type: 1}">
      <template v-slot:query="{form}">
        <a-form-model-item label="">
          <a-input v-model="form.dining_type" placeholder="输入用餐规格查询" style="width: 200px"></a-input>
        </a-form-model-item>
      </template>
      <template v-slot:action="{item}">
        <div class="txt-btn" @click="assignPerson(item)">分配人员</div>
      </template>
    </data-list>
    <a-modal
      title="分配人员"
      :maskClosable="false"
      :width="600"
      :footer="null"
      @ok="visible=false"
      v-model="visible">
      <div class="meal-assign" v-if="meal">
        <div class="other-title">用餐规格</div>
        <detail-view :list="meal.detailList" full class="meal-info"></detail-view>
        <div class="flex-box align-center" style="margin-bottom: 10px">
          <div class="other-title" style="margin-bottom: 0">已分配嘉宾/随行人员</div>
          <person-picker
            multiple
            select-disable
            url="/activity/activity-guest"
            title="选择嘉宾/随行人员"
            :value="meal.dingAllocation ? meal.dingAllocation.map(p => p.guest) : []"
            :query="`&filter[activity_id]=${activity.id}`"
            @change="handleSelect">
            <a-button type="primary" style="margin-left: 10px"><a-icon type="plus-circle" />添加嘉宾/随行人员</a-button>
          </person-picker>
        </div>
        <div class="assign-person-list" v-if="meal.dingAllocation && meal.dingAllocation.length > 0">
          <div class="assign-person-item" v-for="(person, i) in meal.dingAllocation" :key="person.id">
            <div class="assign-person-info">
              <a-icon class="assign-person-icon" type="user" />
              <div class="assign-person-name">{{person.guest ? person.guest.name : '未知'}}</div>
              <a-icon type="close" class="assign-person-operate" @click="removePersonAssign(i)"/>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
    import DetailView from "../../../components/detail-view";
    import personPicker from "../../../components/form/person-picker";
    import {getDate} from "../../../common/js/tool";
    import mixins from "../mixins";

    export default {
        name: "MealAssign",
        components: {
            personPicker,
            DetailView
        },
        mixins: [mixins],
        data() {
            return {
                columns: [
                    {title: '酒店名称', dataIndex: 'hotel_name'},
                    {title: '酒店地址', dataIndex: 'hotel_address'},
                    {title: '用餐地点', dataIndex: 'dining_place'},
                    {title: '用餐类型', dataIndex: 'dining_type'},
                    {
                        title: '用餐时间',
                        dataIndex: 'dinner_start_time',
                        width: 300,
                        customRender: (text, record) => `${getDate(text).pattern("yyyy-MM-dd HH:mm")} 至 ${getDate(record.dinner_end_time).pattern("yyyy-MM-dd HH:mm")}`
                    },
                    {
                        title: '分配状态',
                        dataIndex: 'dingAllocation',
                        customRender: text => text && text.length > 0 ? '已分配' : '未分配'
                    },
                ],
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                meal: null,
                visible: false,
                moduleKey: 'meal-assign',
            }
        },
        computed: {
            action() {
                return this.$route.meta.action;
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '&expand=dingAllocation';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            },
        },
        methods: {
            removePersonAssign(i) {
                const list = this.meal.dingAllocation;
                const item = list[i];
                this.$confirm({
                    title: "提示",
                    content: `确定将${item.guest ? item.guest.name : '此人'}从该用餐分配中移除吗？`,
                    onOk: () => {
                        let url = `/activity/activity-dining-allocation/${item.id}`;
                        this.$axios({
                            url,
                            method: "DELETE",
                        }).then(() => {
                            this.$message.success("已移除");
                            list.splice(i, 1);
                        });
                    },
                    onCancel: () => {},
                });
            },
            handleSelect(list) {
                if(list && list.length > 0) {
                    const url = '/activity/activity-dining-allocation/add-guest';
                    const meal = this.meal;
                    this.$axios({
                        url,
                        method: 'POST',
                        data: {
                            activity_id: meal.activity_id,
                            dining_id: meal.id,
                            guest_id: list.map(s => s.id).join(",")
                        }
                    }).then(res => {
                        if(res.error == 0) {
                            this.getMealAssign();
                            this.$message.success("已添加");
                        } else {
                            this.$message.warning(res.msg || '添加失败');
                        }
                    })
                }
            },
            getMealAssign() {
                const meal = this.meal;
                if(meal) {
                    const url = `/activity/activity-dining-allocation?pageSize=1000&expand=guest&filter[dining_id]=${meal.id}`;
                    this.$axios(url).then(res => {
                        const list = res.data;
                        this.$set(meal, 'dingAllocation', list);
                    });
                }
            },
            assignPerson(record) {
                record.detailList = [
                    {label: '酒店名称', value: record.hotel_name},
                    {label: '酒店地址', value: record.hotel_address},
                    {label: '用餐地点', value: record.dining_place},
                    {label: '用餐类型', value: record.dining_type},
                    {label: '用餐时间', value: `${getDate(record.dinner_start_time).pattern("yyyy-MM-dd HH:mm")} 至 ${getDate(record.dinner_end_time).pattern("yyyy-MM-dd HH:mm")}`},
                ]
                this.meal = record;
                this.visible = true;
            },
        }
    }
</script>

<style scoped lang="less">
</style>
